<template>
  <Breadcrumbs
      title="Create Distributor Vehicle"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Vehicles', path: '/distributor-vehicles' },
      { label: 'Create Distributor Vehicle', path: '/new-vehicle' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newVehicle/>
    </div>
  </div>
</template>

<script>
import newVehicle from './new_vehicle_form.vue'
export default {
  name: 'newVehicleIndex',
  components: {
    newVehicle,
  },
}
</script>